import {classNames, layout} from "@variocube/cube-ui";
import * as React from "react";
import {PropsWithChildren} from "react";
import {stylesheet} from "typestyle";
import infoIcon from "./info.svg";

interface InfoBoxProps {
    className?: string;
}

export function InfoBox({className, children}: PropsWithChildren<InfoBoxProps>) {
    return (
        <div className={classNames(layout.horizontal, layout.alignCenter, className)}>
            <img src={infoIcon} className={styles.infoIcon}/>
            <div>
                {children}
            </div>
        </div>
    )
}

const styles = stylesheet({
    infoIcon: {
        width: "2.5em",
        marginRight: "0.75em"
    },
})